module.exports = __webpack_public_path__ + "static/media/entj.201538c4.png";